import { occBaseSiteUrl } from "~/app/api/occ/occFetch";
import { occCartUserPath } from "~/app/api/occ/occUserPath";
import { resolveActiveCartResourceId } from "~/domains/cart/utils/cartResourceIdentity";

export async function resolveAddCartToWishlistApiUrl(): Promise<string> {
  const activeCartId = await resolveActiveCartResourceId();
  if (!activeCartId) {
    throw new Error("Cannot copy cart to wishlist without an explicit Active Cart identity");
  }

  return occBaseSiteUrl(`${occCartUserPath()}/carts/${encodeURIComponent(activeCartId)}/wishlist/addCart`);
}
